import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";
import { updateTenantUsers } from "../../../utils/UserUtils";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

const useAssignCloudOwnership = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const assignCloudOwnership = useMutation({
    mutationFn: ({
      newUserID,
      permissionProfile,
    }: {
      newUserID: string;
      permissionProfile: any;
      onSuccess?: () => void;
    }) => {
      return TenantAPI.assignCloudOwnership(newUserID, permissionProfile);
    },
    onSuccess: (data, { onSuccess }) => {
      const { oldOwner, newOwner } = data.data.data;

      queryClient.invalidateQueries({
        queryKey: ["user", tenantID],
      });

      queryClient.invalidateQueries({
        queryKey: ["tenantUsers", tenantID],
      });

      // Update user cache -> TenantUsers and current user
      updateTenantUsers(queryClient, tenantID || "", [oldOwner, newOwner]);

      callFunctionIfExists(onSuccess);
    },
  });

  return {
    assignCloudOwnership: assignCloudOwnership.mutate,
    assigningCloudOwnership: assignCloudOwnership.isPending,
    assignCloudOwnershipError: assignCloudOwnership.error
      ? getErrorMessage(assignCloudOwnership.error)
      : null,
  };
};

export default useAssignCloudOwnership;
